/**
 * `await bevestig({ titel, tekst, knop, gevaarlijk })` → true/false.
 *
 * Imperatief zodat elke handler het in één regel kan gebruiken, zonder state en JSX per
 * scherm. Rendert in een eigen React-root onder <body>; MUI-standaardthema is hier prima.
 */
import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import ConfirmDialog from '../ui-components/ConfirmDialog';

let host = null;
let root = null;

export function bevestig(opties = {}) {
  return new Promise((resolve) => {
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-bevestig', '');
      document.body.appendChild(host);
      root = createRoot(host);
    }
    const sluit = (uitkomst) => {
      root.render(createElement(ConfirmDialog, { ...opties, open: false, onConfirm: () => {}, onClose: () => {} }));
      resolve(uitkomst);
    };
    root.render(createElement(ConfirmDialog, { ...opties, open: true, onConfirm: () => sluit(true), onClose: () => sluit(false) }));
  });
}

export default bevestig;
